<div
    class="container header-observation-focus-summary"
    *ngIf="focus?.behaviourId != null && state?.calculationResult"
>
    <div class="published-overall-row">
        <div class="indicators-header">
            <strong>{{ _i18n._9113_PUBLISHED | translate }}</strong>
        </div>
        <div class="indicators-container">
            <div class="indicator-group">
                <div class="indicator-group-left">
                    <strong>{{
                        _i18n._9567_OPPORTUNITY_TO_DEMONSTRATE | translate
                    }}</strong>
                </div>
                <div class="indicator-group-right">
                    {{
                        state?.calculationResult?.opportunityToDemonstrate
                            | percent
                    }}
                </div>
            </div>
            <div class="indicator-group">
                <div class="indicator-group-left">
                    {{ _i18n._9568_WILLINGNESS_TO_TRY | translate }}
                </div>
                <div class="indicator-group-right">
                    {{ state?.calculationResult?.willingnessToTry | percent }}
                </div>
            </div>
            <div class="indicator-group">
                <div class="indicator-group-left">
                    {{ _i18n._9644_PROFICIENCY_SCORE | translate }}
                </div>
                <div class="indicator-group-right">
                    {{ state?.calculationResult?.proficiency | percent }}
                </div>
            </div>
        </div>
    </div>
    <div
        class="session-overall-row"
        *ngIf="!hideSubSummary"
    >
        <div class="small-indicators-header"></div>
        <div class="small-indicators-container">
            <div class="small-indicators-group">
                <span class="bottom-titles">{{
                    _i18n._9661_SCORES_FROM_THIS_SESSION | translate
                }}</span>
                <div class="small-indicators-box">
                    {{
                        state?.calculationResult
                            ?.opportunityToDemonstrateSession | percent
                    }}
                </div>
            </div>
            <div class="small-indicators-group">
                <span class="bottom-titles-2">{{
                    _i18n._9662_PENDING_OVERALL | translate
                }}</span>
                <div class="small-indicators-box-light">
                    {{
                        state?.calculationResult?.opportunityToDemonstrateAll
                            | percent
                    }}
                </div>
            </div>
            <div class="small-indicators-group">
                <span class="bottom-titles">{{
                    _i18n._9661_SCORES_FROM_THIS_SESSION | translate
                }}</span>
                <div class="small-indicators-box">
                    {{
                        state?.calculationResult?.willingnessToTrySession
                            | percent
                    }}
                </div>
            </div>
            <div class="small-indicators-group">
                <span class="bottom-titles-2">{{
                    _i18n._9662_PENDING_OVERALL | translate
                }}</span>
                <div class="small-indicators-box-light">
                    {{
                        state?.calculationResult?.willingnessToTryAll | percent
                    }}
                </div>
            </div>
            <div class="small-indicators-group">
                <span class="bottom-titles">{{
                    _i18n._9661_SCORES_FROM_THIS_SESSION | translate
                }}</span>
                <div class="small-indicators-box">
                    {{ state?.calculationResult?.proficiencySession | percent }}
                </div>
            </div>
            <div class="small-indicators-group">
                <span class="bottom-titles-2">{{
                    _i18n._9662_PENDING_OVERALL | translate
                }}</span>
                <div class="small-indicators-box-light">
                    {{ state?.calculationResult?.proficiencyAll | percent }}
                </div>
            </div>
        </div>
    </div>
</div>
